/*
 * @Description: 商城tab栏目
 * @Author: 蔺晨
 * @Date: 2020-03-17 19:44:53
 * @LastEditors: JettyHuang
 * @LastEditTime: 2021-03-24 15:22:47
 */
import React, { Component } from 'react';
import { Flex } from 'antd-mobile';
// import Util from 'util';
import './index.less';

/* tabs
 * leftContent
 * rightContent
 * expandContent
 */

class TabBarView extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    // return (<Flex>adsf</Flex>);
    return <div>sdfadsaf</div>;
  }
}

module.exports = TabBarView;



// WEBPACK FOOTER //
// ./src/pubBiz/TabBar/index.js